import { Box, Heading } from '@simplywallst/ui-core';

interface Props {
  children: React.ReactNode;
}

const PopularScreens = ({ children }: Props) => (
  <Box
    marginBottom="x2"
    paddingY="x2"
    paddingX="x3"
    borderRadiusLg="x1_5"
    backgroundColor="noir"
  >
    <Heading as="h2" typography="smallStrong">
      Popular Screens
    </Heading>
    {children}
  </Box>
);

export default PopularScreens;
